<template>
  <header
    class="header"
    :class="{
      open: openMenu,
      navExpanded: openNav,
      menuActivated: !!menu,
      'header--news': isNewsPage,
      'header--blog': isBlogPage
    }"
    v-sticky="sticky"
    role="banner"
  >
    <div class="header__content">
      <slot
        name="banner"
        :isBannerDisable="isBannerDisable"
        :closeBanner="closeBanner"
      />
      <div class="header__top">
        <button
          type="button"
          class="header__burger"
          @click="
            (openMenu = !openMenu),
              (openNav = !openNav),
              setFocus('button.header__close')
          "
          :class="{ open: openMenu }"
        >
          <span v-if="!openMenu" class="sr-only">Main Navigation Menu</span>
          <span v-else class="sr-only">Close Menu</span>
          <span class="header__burger--line header__burger--top" />
          <span class="header__burger--line header__burger--center" />
          <span class="header__burger--line header__burger--bottom" />
        </button>

        <slot name="header-target" v-if="screenSize === 'large'" />

        <div class="header__logo" :class="{ open: openMenu }">
          <slot name="header-logo" />
        </div>

        <nav
          role="navigation"
          class="header__info"
          :aria-label="allyUtilityLabel"
        >
          <slot name="header-stock" v-if="screenSize === 'large'" />

          <div class="header__accessibility" v-if="screenSize === 'large'">
            <slot name="header-accessibility" />
          </div>

          <div class="header__country" v-if="screenSize === 'large'">
            <slot name="header-country" />
          </div>

          <div class="header__language" v-if="screenSize === 'large'">
            <slot name="header-language" :changelang="changelang" />
          </div>

          <a
            :href="searchUrl"
            role="search"
            class="header__search"
            :class="{ open: openMenu }"
            v-if="iconDisable"
          >
            <div aria-hidden="true" class="icon icon-search" />
            <span class="off-screen">
              <slot name="header-search" />
            </span>
          </a>
        </nav>
      </div>

      <div
        class="header__overlay"
        v-if="openMenu"
        @click="(openMenu = false), (openNav = false)"
      />

      <div class="header__submenu mobileMenu" :class="{ open: openMenu }">
        <button
          class="header__close"
          @click="
            (openMenu = !openMenu),
              (openNav = false),
              setFocus('.header__burger')
          "
          v-if="screenSize === 'small' || screenSize === 'medium'"
        >
          <div class="header__burger" :class="{ open: openMenu }">
            <span class="header__burger--line header__burger--top" />
            <span class="header__burger--line header__burger--center" />
            <span class="header__burger--line header__burger--bottom" />
          </div>
        </button>

        <slot
          :isNavigationOpened="isNavigationOpened"
          :openNav="openNav"
          name="navigation"
        />

        <div class="mobileMenu__bottom" v-if="screenSize !== 'large'">
          <div class="mobileMenu__stock">
            <slot name="header-stock" />
          </div>

          <slot name="header-target" />

          <div class="mobileMenu__info">
            <div class="mobileMenu__accessibility">
              <slot name="header-accessibility" />
            </div>
            <div class="mobileMenu__country">
              <slot name="header-country" />
            </div>
            <div class="mobileMenu__language">
              <slot name="header-language" :changelang="changelang" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import { sticky } from '@Foundation/directives/sticky/sticky';
  import { customVhProperty } from '@Foundation/utilities';
  import { checkScreenSize } from '@Foundation/mixins/checkScreenSize';
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'header-site',

    directives: {
      sticky
    },

    mixins: [checkScreenSize],

    props: {
      allyUtilityLabel: { type: String, default: 'utils' },
      searchUrl: { type: String, default: '#' }
    },
    data() {
      return {
        openMenu: false,
        openNav: false,
        menu: null,
        sticky: '.header__content',
        isBannerDisable: true,
        isNewsPage: false,
        isBlogPage: false,
        isPageScrolled: false,
        timeInterval: null,
        timing: 0,
        isTimeLimitCrossed: false,
        isDataLayerPushed: false,
        articleTitle: '',
        escapeClassName: 'escape--pressed',
        iconDisable: false
      };
    },

    watch: {
      openMenu(value) {
        const body = document.querySelector('body');

        if (value) {
          body.classList.add('body-hide-overflow');
        } else {
          body.classList.remove('body-hide-overflow');
        }
      }
    },

    mounted() {
      customVhProperty();
      this.isBannerDisable = sessionStorage.getItem('bannerDiasble')
        ? true
        : false;
      const findNewPage = document.getElementsByClassName('hero--news');
      const breadCrumbsNews = document.getElementsByClassName('breadcrumbs');
      if (findNewPage.length) {
        this.isNewsPage = true;
        if (breadCrumbsNews && breadCrumbsNews.length) {
          breadCrumbsNews[0].classList.add('breadcrumbs--news');
          breadCrumbsNews[0].parentElement.classList.add(
            'breadcrumbs__container'
          );
        }
      } else {
        this.isNewsPage = false;
        if (breadCrumbsNews && breadCrumbsNews.length) {
          breadCrumbsNews[0].classList.remove('breadcrumbs--news');
          breadCrumbsNews[0].parentElement.classList.remove(
            'breadcrumbs__container'
          );
        }
      }
      const findBreadcum = document.querySelector('.breadcrumbs');
      if (findBreadcum !== null) {
        this.articleTitle = document.querySelector(
          '.breadcrumbs > ul > li:last-child > span > span > strong'
        ).innerText;
        if (this.articleTitle.length > 70) {
          document.querySelector(
            '.breadcrumbs > ul > li:last-child > span > span > strong'
          ).innerText = this.articleTitle.substr(0, 70) + '...';
        }
      }
      const isNewsPage = document.getElementsByClassName('Article-Page');
      if (isNewsPage !== null && isNewsPage.length > 0) {
        window.addEventListener('scroll', this.checkPageScroll);
        document.addEventListener('visibilitychange', this.tabVisibilityCheck);
        this.checkUserSpendTime();
      }
      // blog page check if yes then add class header--blog to make it visible
      this.isBlogPage = document.getElementsByClassName('Blog-Page').length > 0 ? true : false;

      if (this.screenSize === 'large') {
        const firstLevelMenu = document.getElementsByClassName(
          'mega-menu__level-1-item'
        );
        window.addEventListener('keydown', e => {
          if (e.key === 'Escape') {
            this.openMenu = false;
            firstLevelMenu.forEach((data, index) => {
              if (
                !this.checkClassAdded(data) &&
                index !== firstLevelMenu.length - 1
              ) {
                data.classList.add(this.escapeClassName);
              }
            });
          }
        });
        var second = document.getElementsByClassName('mega-menu__level-1-item')
          .length;
        if (second > 0) {
          this.iconDisable = true;
        } else {
          this.iconDisable = false;
        }

        firstLevelMenu.forEach(data => {
          data.addEventListener('mouseenter', e => {
            this.removeClass(e.target.classList);
          });
        });
        window.addEventListener('keydown', e => {
          if (e.keyCode === 13) {
            firstLevelMenu.forEach(data => {
              this.removeClass(data.classList);
            });
          }
        });
      }
    },
    methods: {
      checkClassAdded(data) {
        return data.classList.contains(this.escapeClassName);
      },
      removeClass(escapeClass) {
        return escapeClass.remove(this.escapeClassName);
      },
      tabVisibilityCheck() {
        if (document.hidden) {
          this.timing = 0;
          this.clearingInterval();
        } else {
          this.checkUserSpendTime();
        }
      },
      checkUserSpendTime() {
        this.timeInterval = setInterval(() => {
          this.timing += 1;
          if (this.timing === 30) {
            this.isTimeLimitCrossed = true;
            this.readArticlePushDataLayer();
            this.clearingInterval();
          }
        }, 1000);
      },
      clearingInterval() {
        this.timing = 0;
        clearInterval(this.timeInterval);
      },
      readArticlePushDataLayer() {
        if (
          this.isPageScrolled === true &&
          this.isTimeLimitCrossed === true &&
          this.isDataLayerPushed === false
        ) {
          this.isDataLayerPushed = true;
          AnalyticsHandler.pushDataLayer({
            event: 'uaevent',
            ecommerce: 'undefined',
            eventCategory: 'content page::article',
            eventAction: 'read article',
            eventLabel: this.articleTitle
          });
        }
      },
      checkPageScroll() {
        var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

        var percent =
          ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
        if (percent >= 75) {
          this.isPageScrolled = true;
          this.readArticlePushDataLayer();
        }
      },
      isNavigationOpened(value) {
        this.openNav = value.open;
        this.menu = value.menu;
      },
      changelang(e) {
        const link = e.target.options[e.target.options.selectedIndex].value;
        let value = link.slice(1);
        value = value.substring(0, value.indexOf('/'));

        AnalyticsHandler.pushDataLayer({
          event: 'uaevent',
          eventCategory: 'main menu',
          eventAction: 'select::language',
          eventLabel: value
        });

        window.location.href = link;
      },
      setFocus(element) {
        setTimeout(() => {
          this.$el.querySelector(element) &&
            this.$el.querySelector(element).focus();
        }, 300);
      },
      closeBanner() {
        this.isBannerDisable = true;
        sessionStorage.setItem('bannerDiasble', true);
      }
    }
  };
</script>
